import { api } from '../../lib/api';
import { useResource } from '../../lib/useResource';
import type { FinanceData } from './types';

// The Finances data source: GET /api/finances/overview through the shared API
// client + SWR engine (same pattern as the other pages). Locally this hits the
// API on :8787 → Neon dev DB; in production it reads the prod DB. No client-side
// mock — the page renders whatever the database holds.
export function useFinancesData() {
  const { state } = useResource<FinanceData>(
    'finances:overview',
    () => api<FinanceData>('/finances/overview').then((e) => e.data),
  );
  return state; // { phase, data, hydrated }
}
